/**
 * Typography used in theme
 * @param {JsonObject} theme theme customization object
 */
export default function themeTypography(theme) {
  return {
    fontFamily: '"Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif',
    h6: {
      fontWeight: 600,
      color: theme.heading,
      fontSize: '0.875rem',
      letterSpacing: 0
    },
    h5: {
      fontSize: '1rem',
      color: theme.heading,
      fontWeight: 600,
      letterSpacing: 0
    },
    h4: {
      fontSize: '1.125rem',
      color: theme.heading,
      fontWeight: 600,
      letterSpacing: 0
    },
    h3: {
      fontSize: '1.375rem',
      color: theme.heading,
      fontWeight: 700,
      letterSpacing: 0
    },
    h2: {
      fontSize: '1.75rem',
      color: theme.heading,
      fontWeight: 700,
      letterSpacing: 0
    },
    h1: {
      fontSize: '2.25rem',
      color: theme.heading,
      fontWeight: 700,
      letterSpacing: 0
    },
    subtitle1: {
      fontSize: '1rem',
      fontWeight: 500,
      color: theme.textDark,
      letterSpacing: 0
    },
    subtitle2: {
      fontSize: '0.875rem',
      fontWeight: 500,
      color: theme.darkTextSecondary,
      letterSpacing: 0
    },
    caption: {
      fontSize: '0.75rem',
      color: theme.darkTextSecondary,
      fontWeight: 400,
      letterSpacing: '0em'
    },
    body1: {
      fontSize: '1rem',
      fontWeight: 400,
      lineHeight: '1.5em',
      letterSpacing: 0
    },
    body2: {
      fontSize: '0.875rem',
      letterSpacing: '0em',
      fontWeight: 400,
      lineHeight: '1.5em',
      color: theme.darkTextPrimary
    },
    customInput: {
      marginTop: 8,
      marginBottom: 8,
      '& > label': {
        top: '23px',
        left: 0,
        color: theme.grey500,
        '&[data-shrink="false"]': {
          top: '5px'
        }
      },
      '& > div > input': {
        padding: '30.5px 14px 11.5px !important'
      },
      '& legend': {
        display: 'none'
      },
      '& fieldset': {
        top: 0
      }
    },
    mainContent: {
      backgroundColor: theme.background,
      width: '100%',
      minHeight: 'calc(100vh - 76px)',
      flexGrow: 1,
      padding: '18px',
      marginTop: '76px',
      marginRight: '18px',
      borderRadius: `${theme.customization.borderRadius}px`
    },
    menuCaption: {
      fontSize: '0.875rem',
      fontWeight: 600,
      color: theme.heading,
      padding: '8px',
      textTransform: 'capitalize',
      marginTop: '12px',
      letterSpacing: 0
    },
    subMenuCaption: {
      fontSize: '0.75rem',
      fontWeight: 500,
      color: theme.darkTextSecondary,
      textTransform: 'capitalize',
      letterSpacing: 0
    },
    commonAvatar: {
      cursor: 'pointer',
      borderRadius: '12px'
    },
    smallAvatar: {
      width: '24px',
      height: '24px',
      fontSize: '0.875rem'
    },
    mediumAvatar: {
      width: '40px',
      height: '40px',
      fontSize: '1rem'
    },
    largeAvatar: {
      width: '56px',
      height: '56px',
      fontSize: '1.25rem'
    }
  };
}
